import * as React from 'react';
import { useTheme } from '@material-ui/core';
function CheckMarkOutline(props) {
  var size = props.size === 'xlarge' ? 64 : 24;
  var theme = useTheme();
  var color = props.color ? theme.palette[props.color].main : 'currentColor';
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    width: size,
    height: size,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": props['aria-label'],
    "aria-hidden": props['aria-hidden']
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.707 6.293a1 1 0 010 1.414L9 18.414l-4.707-4.707a1 1 0 111.414-1.414L9 15.586l9.293-9.293a1 1 0 011.414 0z",
    fill: color
  }));
}
export default CheckMarkOutline;